// extracted by mini-css-extract-plugin
export var avatarBone = "_7-5";
export var body = "_7-b";
export var bone = "_7-0";
export var brandGroup = "_7-4";
export var cardBone = "_7-i";
export var descBone = "_7-f";
export var divider = "_7-a";
export var grid = "_7-h";
export var header = "_7-2";
export var iconTagBone = "_7-8";
export var leftColumn = "_7-c";
export var leftInner = "_7-d";
export var nameBone = "_7-6";
export var navBar = "_7-3";
export var rightColumn = "_7-g";
export var rightGroup = "_7-7";
export var skeletonPulse = "_7-1";
export var tagBone = "_7-9";
export var titleBone = "_7-e";